import { useWorkshopParts } from '../einkauf/useWorkshopParts'

/** Einkauf-Übersicht: Teile-Bestellpipeline auf einen Blick (wartet / bestellt / geliefert). */
export function PartsStatus() {
  const { data } = useWorkshopParts()
  if (!data) return null

  const count = (status: string) => data.parts.filter((p) => p.status === status).length

  return (
    <section aria-label="Teile-Status">
      <div className="wf-sectionhead">
        <h3>Teile-Status</h3>
      </div>
      <div className="wf-kpigrid">
        <div className="wf-stat wf-stat--wartet">
          <div className="wf-stat__label">Wartet auf Bestellung</div>
          <div className="wf-stat__value">{count('needed')}</div>
          <div className="wf-stat__sub">noch zu bestellen</div>
        </div>
        <div className="wf-stat wf-stat--arbeit">
          <div className="wf-stat__label">Bestellt</div>
          <div className="wf-stat__value">{count('ordered')}</div>
          <div className="wf-stat__sub">unterwegs</div>
        </div>
        <div className="wf-stat wf-stat--fertig">
          <div className="wf-stat__label">Geliefert</div>
          <div className="wf-stat__value">{count('delivered')}</div>
          <div className="wf-stat__sub">einbaubereit</div>
        </div>
      </div>
    </section>
  )
}
